export const prerender = true;

import { locales } from '../../../locales/data';
import type { EntryGenerator } from './$types';

export const entries: EntryGenerator = () => {
	return locales.filter((locale) => locale != 'en').map((locale) => ({ locale: locale }));
};
